import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./Analytics')));
const Dashboard = Loadable(lazy(() => import('./Dashboard')));

const dashboardRoutes = [
  { path: '/dashboard/default', element: <Analytics />, auth: authRoles.admin },
  { path: '/dashboard/main', element: <Dashboard />, auth: authRoles.admin },
];

export default dashboardRoutes;
